module.exports = __webpack_public_path__ + "img/17.5ff596f4.png";